import * as React from 'react'
import { connect } from 'react-redux'
import * as Types from 'DVWebNodeWpsRuntime'
import { Parameters } from 'DVWebNodeUtils'
import { Link, Spacing } from 'DVWebNodeUI'
import { TextLocalizer } from '../localizer/localizer'
import { StringId } from '../localizer/stringId'
import { RecordRefTag } from '../recordReftag/recordReftag'
import { buildDetailPageUrl, buildSignInUrl } from '../../utils/url'
import { IDetailPageState } from '../../reducers'
import { IRequestContext } from '../../selectors/requestContext'
import { shouldShowMoreWaysToWatch } from '../morePurchaseOptions/btfMorePurchaseOptions'
import { redeemAndPromoComponentSelector } from '../../selectors/component/actionBoxComponentSelectors'
import { CloseModal } from '../../utils/ModalTrigger'

export interface IRedeemAndPromoLinkProps {
  placement: 'MWTW' | 'ActionBox'
  closeModal?: CloseModal
}

export interface IRecognizedLink {
  onClick?: () => void
  requestID: string
}

export interface IUnrecognizedLink {
  parameters: Parameters
  originalURI: string
  titleID: string
  isRetail: boolean
}

type IStateProps = {
  isRedeemAndPromoRestricted: boolean
  hasTvodWinnerOffer: boolean
  moreWaysToWatch?: Types.atv.wps.AcquisitionActionTreeModelProps
  titleID: string
  requestContext: IRequestContext
}

const getRedeemAndPromoUrl = (requestId: string) =>
  `/gp/video/watch-options/ajax/gift-card/ref=atv_dp_bb_gc_js?ie=UTF8&relatedRequestId=${requestId}`

const RecognizedLink = ({ onClick, requestID }: IRecognizedLink) => {
  const redeemAndPromoString = (
    <TextLocalizer stringID={StringId.AVOD_DP_redeem_gift_card_or_promotion} />
  )
  const redeemAndPromoUrl = getRedeemAndPromoUrl(requestID)
  const modalData = {
    width: 540,
    showImmediately: 1,
    hasScrollableContent: 'true',
    id: 'gift-card-promo',
    hideHeader: 1,
    theme: 'dark',
    url: redeemAndPromoUrl
  }

  const linkAttrs = {
    href: redeemAndPromoUrl,
    className: 'a-declarative',
    'data-action': 'aiv-modal',
    'data-aiv-modal': JSON.stringify(modalData),
    name: 'gift-card-promo'
  }
  return (
    <RecordRefTag refTag='dv-gcp-modal'>
      <Link onClick={onClick} {...linkAttrs}>{redeemAndPromoString}</Link>
    </RecordRefTag>
  )
}

const UnrecognizedLink = ({
  titleID,
  parameters,
  originalURI,
  isRetail
}: IUnrecognizedLink) => {
  const dpUrl = buildDetailPageUrl(
    { parameters, originalURI, isRetail },
    titleID,
    'dv_dp_gc_sign_in'
  )
  const signInUrl = buildSignInUrl(
    { parameters, originalURI, isRetail },
    'dv_dp_gc_sign_in',
    dpUrl
  )
  return (
    <Link href={signInUrl}>
      <TextLocalizer
        stringID={StringId.AVOD_DP_redeem_gift_card_or_promotion}
      />
    </Link>
  )
}

export const ConnectedRedeemAndPromoLink = ({
  isRedeemAndPromoRestricted,
  hasTvodWinnerOffer,
  titleID,
  moreWaysToWatch,
  placement,
  closeModal,
  requestContext: {
    isRecognizedCustomer,
    requestID,
    parameters,
    originalURI,
    isRetail
  }
}: IRedeemAndPromoLinkProps & IStateProps) => {
  // No Redeem Gift Card and Promo popup when it is restricted
  // No Offers or Redeem Gift Card and Promo popup link is already in the MoreWaysToWatch popup
  // No Redeem Gift Card and Promo popup on primevideo.com
  if (isRedeemAndPromoRestricted || !isRetail || placement === 'ActionBox' && (!hasTvodWinnerOffer || shouldShowMoreWaysToWatch(moreWaysToWatch))) {
    return null
  }

  return (
    <div className={`${Spacing.medium} dv-gift-card-wrapper`}>
      {isRecognizedCustomer ? (
        <RecognizedLink onClick={() => closeModal && closeModal()} requestID={requestID} />
      ) : (
          <UnrecognizedLink
            titleID={titleID}
            parameters={parameters}
            originalURI={originalURI}
            isRetail={isRetail}
          />
        )}
    </div>
  )
}

const mapStateToProps = (state: IDetailPageState): IStateProps => redeemAndPromoComponentSelector(state)

export const RedeemAndPromoLink = connect(mapStateToProps)(
  ConnectedRedeemAndPromoLink
)
